export default {
  api: [{ rule: "bq_summary.read", allow: true }],
  page: [{ rule: "investigate/search", allow: true }],
};
